import api from './api';

export const getManagers = async () => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('No authentication token found');
    }

    const response = await api.get('/api/Manager/GetManagers', {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching managers:', error);
    throw error;
  }
};

export const addManager = async (data) => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('No authentication token found');
    }

    // Validate required fields
    if (!data.name) throw new Error('Ad Soyad alanı zorunludur');

    // Convert file to base64 if it exists and is not already base64
    let pictureBase64 = data.pictureBase64;
    if (data.picture && typeof data.picture !== 'string') {
      pictureBase64 = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(data.picture);
        reader.onload = () => {
          const result = reader.result;
          if (!result) {
            reject(new Error('Resim okunamadı'));
            return;
          }
          resolve(result);
        };
        reader.onerror = error => {
          console.error('Resim okuma hatası:', error);
          reject(new Error('Resim okuma sırasında bir hata oluştu'));
        };
      });
    }

    const payload = {
      name: data.name,
      positionName: data.positionName,
      phone: data.phone || '',
      fax: data.fax || '',
      email: data.email,
      dutyAndResponsibility: data.dutyAndResponsibility || '',
      mission: data.mission || '',
      vision: data.vision || '',
      pictureBase64: pictureBase64 || '',
      sequenceNr: data.sequenceNr || 0
    };

    console.log('Sending manager payload:', {
      ...payload,
      pictureBase64: payload.pictureBase64 ? '(base64 data present)' : '(no picture)'
    });

    const response = await api.post('/api/Manager/AddManager', payload, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    console.log('Manager API Response:', response);
    // Backend ServiceResult döndürüyor
    return response;
  } catch (error) {
    console.error('Error adding manager:', {
      message: error.message,
      response: error.response?.data,
      status: error.response?.status,
      headers: error.response?.headers
    });
    throw error;
  }
};

export const updateManager = async (guid, data) => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('No authentication token found');
    }

    if (!guid) {
      throw new Error('Manager ID is required');
    }

    // Validate required fields
    if (!data.name) throw new Error('Ad Soyad alanı zorunludur');

    // Convert file to base64 if it exists and is not already base64
    let pictureBase64 = data.pictureBase64;
    if (data.picture && typeof data.picture !== 'string') {
      pictureBase64 = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(data.picture);
        reader.onload = () => {
          const result = reader.result;
          if (!result) {
            reject(new Error('Resim okunamadı'));
            return;
          }
          resolve(result);
        };
        reader.onerror = error => {
          console.error('Resim okuma hatası:', error);
          reject(new Error('Resim okuma sırasında bir hata oluştu'));
        };
      });
    }

    const payload = {
      guid: guid,
      name: data.name,
      positionName: data.positionName,
      phone: data.phone || '',
      fax: data.fax || '',
      email: data.email,
      dutyAndResponsibility: data.dutyAndResponsibility || '',
      mission: data.mission || '',
      vision: data.vision || '',
      pictureBase64: pictureBase64 || '',
      sequenceNr: data.sequenceNr || 0
    };

    console.log('Sending manager update payload:', {
      ...payload,
      pictureBase64: payload.pictureBase64 ? '(base64 data present)' : '(no picture)'
    });

    const response = await api.post('/api/Manager/UpdateManager', payload, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    console.log('Manager Update API Response:', response);
    // Backend ServiceResult döndürüyor
    return response;
  } catch (error) {
    console.error('Error updating manager:', {
      message: error.message,
      response: error.response?.data,
      status: error.response?.status,
      headers: error.response?.headers
    });
    throw error;
  }
};

export const deleteManager = async (guid) => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('No authentication token found');
    }

    if (!guid) {
      throw new Error('Manager ID is required');
    }

    const response = await api.post('/api/Manager/DeleteManager', { guid }, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    // API 200 dönüyorsa başarılıdır
    return response;
  } catch (error) {
    console.error('Error deleting manager:', error);
    throw error;
  }
};
